<template>
  <div class="component-detail-base-history">
    <div class="search-hd">
      <el-form
        :inline="true"
        size="mini"
        @submit.native.prevent
      >
        <el-form-item style="float:right">
          <custom-date-picker
            @change="getData('init')"
            style="width: 260px"
            v-model="times"
            :init-value="initTimer"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="eventIntervalDays"
            size="small"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :index="true"
        :column="tableColumn"
        :isDrag="false"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        @drag="dragChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <el-pagination
        border
        v-if="totalRows"
        @size-change="getData('init')"
        @current-change="getData"
        :current-page.sync="formSearch.pageNum"
        :page-size.sync="formSearch.pageSize"
        :page-sizes="pageSizeList"
        layout="sizes, prev, pager, next, slot, jumper"
        :total="totalRows"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable.vue';
import apis from '@/utils/apis.js';
import moment from 'moment';

export default {
  components: {
    customTable
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formSearch: {
        pageSize: 20,
        pageNum: 1
      },
      times: [],
      initTimer: [moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
      tableList: [],
      tableColumn: [],
      totalRows: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(data) {
      if (data === 'init') {
        this.formSearch.pageNum = 1;
      }
      this.$getJSON(apis.modemBatteryComponentBaseHistPage, this.getReqData()).then((res) => {
        this.tableList = res.data.pageData.list;
        this.totalRows = res.data.pageData.total;
        if (!this.tableColumn.length) {
          this.tableColumn = this.formatCol(res.data.tableColumns);
        }
      });
    },
    getReqData() {
      return {
        ...this.formSearch,
        startDate: this.times && this.times[0] ? this.times[0] : '',
        endDate: this.times && this.times[1] ? this.times[1] : '',
        modemSn: this.model.modemSn,
        componentCode: this.model.componentCode
      };
    },
    formatCol(list) {
      let shouldFix = true;
      list.forEach((item) => {
        item.columnId = item.tslDataId;
        item.columnName = `${item.dataName} ${item.showUnit ? `${item.showUnit}` : ''}`;
        item.columnCode = item.dataCode;
        item.selected = true;
        item.langColumnName = item.langDataName;
        item.width = item.columnWidth;
        if (item.dicGroup) {
          item.formatRule = 'dic_group';
          item.isFormat = 1;
        }
        if (item.dataType === 'Date') {
          item.formatRule = 'dic_group';
          item.dicGroup = 'tableField_dateFormat_datetime';
          item.formatRule = 'tableField_date';
          item.isFormat = 1;
          // 只给开头连续的日期列添加fixed属性
          if (shouldFix) {
            item.isFixed = true;
            item.fixedPosition = 'left';
          }
        } else {
          // 一旦遇到非日期列，后续不再添加fixed属性
          shouldFix = false;
        }
      });
      return list;
    },
    dragChange({ newWidth, col }) {
      this.$postJSON(`${apis.TopicTslColumnWidthSetup}/${col.topicId}/${col.tslDataId}/${newWidth}`).then(() => { });
    }
  }
};
</script>

<style lang="scss">
.component-detail-base-history {
  display: flex;
  flex-direction: column;
  height: 100%;
  .el-form-item {
    margin-bottom: 0 !important;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
